import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('./views/About.vue')
        },
        // Route for lsiting products
        {
            path: '/products',
            name: 'products',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import( /* webpackChunkName: "about" */ './views/Products.vue')
        },

        // Route for single Product
        {
            path: '/products/:productID',
            name: 'productSingle',
            // pass the 'id' param as a prop to the 'Product' component
            props: true,
            component: () => import('@/components/Product'),
        },
        {
            path: '/projects',
            name: 'projects',
            component: () => import('./views/Projects.vue')
        },
        {
            path: '/designers',
            name: 'designers',
            component: () => import('./views/Designers.vue')
        },
        {
            path: '/tour',
            name: 'tour',
            component: () => import('./views/Tour.vue')
        },

        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('./views/Privacy.vue')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('./views/Contact.vue')
        },




        {
            path: '/cookie',
            name: 'cookie',
            component: () => import('./views/Cookie.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        // catch all 404 pages
        {
            path: '*',
            component: () => import('./views/404.vue')
        }
    ]
})

// Router.beforeEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })